/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Box, Divider, Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ReplayIcon from '@mui/icons-material/Replay';
import { CircularProgress, DialogContentText } from '@mui/material';
import WarningModal from './WarningModal';
import { ReactComponent as VideoSymbol } from '../../assets/images/logos/Video-Demo-Symbol_Exercises.svg';
import KeyboardSymbol from '../../assets/images/logos/Keyboard-Symbol_Exercises.png';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import warningIcon from '../../assets/images/logos/Warning-Symbol_Warning-Message.svg';
import './styles.css';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  directions: {
    paddingRight: '10px'
  }
}));

const TypingTestHeader = ({
  demo,
  instanceData,
  setDemo,
  setResult,
  setText,
  setShowRepsDataValue,
  setWordCount,
  setError,
  setSeconds,
  text,
  setComparison,
  result,
  setAllText,
  TimeLimit,
  setCounter,
  setAutomaticSubmit,
  exerciseType,
  links,
  curentId,
  wpmValue,
  setWpmValue,
  setCounterFlag,
  setSecondflag,
  setKeyData,
  errorValueEach,
  wpmValueEach,
  setErrorValueEach,
  setParagraph,
  paragraph,
  setReplay,
  counter,
  replayClick,
  setReplayClick,
  setResultHTML,
  setResultHTML2,
  setLiftedNextButtonFunction
}) => {
  const location = useLocation();
  const [instructions, setInstructions] = useState();
  const [wpmslag, setWpmslag] = useState(false);
  const [errorslag, setErrorslag] = useState(false);
  const [open, setOpen] = useState(false);
  const [openPrevious, setOpenPrevious] = useState(false);
  const navigate = useNavigate();
  const handleNavigateAway = () => {
    setShowRepsDataValue(0);
    setResult(false);
    setText('');
    setSeconds(0);
    setError(0);
    setWordCount(0);
    setSecondflag(false);
    setComparison([]);
    setAllText('');
    setParagraph('');
    setKeyData({});
    setResultHTML2('');
    setResultHTML('');
    setCounter(() => Number(TimeLimit ?? 0));
    setAutomaticSubmit(false);

    // Find the next visible link
    let nextVisibleLink = links?.links?.slice(index + 1).find(item => item.visible === 1);
    let excercises = localStorage.getItem('exercises') ?? '[]';
    excercises = JSON.parse(excercises);
    if (excercises?.length > 4) {
      let path = window.location.pathname ?? '';
      const instance = path.split('/')[3].split('-')[1];
      const courseIndex = Number(path.split('/')[3].split('.')[0].split('_')[1]) + 3;
      const course = excercises.length >= courseIndex ? excercises[courseIndex] : [];
      course?.modules?.forEach((activity, activityIndex) => {
        if (activity.instance == instance && course?.modules.length + 1 > activityIndex) {
          nextVisibleLink = {
            name: course.modules[activityIndex + 1].name,
            id: course.modules[activityIndex + 1].instance
          };
        }
      });
    }
    if (nextVisibleLink) {
      const path = nextVisibleLink.name.split(' ').includes('Document')
        ? `/courses/editor/${replaced(nextVisibleLink?.name)}-${replaced(nextVisibleLink?.id)}`
        : `/courses/typing/${replaced(nextVisibleLink?.name)}-${replaced(nextVisibleLink?.id)}`;
      navigate(path, { state: links });
      if (exerciseType === 'TimingKeypadEnter') {
        window.location.reload();
      }
    } else {
      console.warn('No next visible exercise found');
      // Optionally navigate to a fallback route or show a message
    }
  };
  // CKey-112
  const navenable = sessionStorage.getItem('navigation') === 'true';

  const handleWarningOpen = () => {
    setCounterFlag(true);
    setOpen(true);
  };

  const handleWarningClose = () => {
    setCounterFlag(false);
    setOpen(false);
  };

  const handlePreviousWarningOpen = () => {
    setOpenPrevious(true);
  };

  const handlePreviousWarningClose = () => {
    setCounterFlag(false);
    setOpenPrevious(false);
  };
  const showVideoDemo = () => {
    setDemo(prevDemo => (prevDemo === true ? null : true));
  };
  const showKeyBoardHint = () => {
    setDemo(prevDemo => (prevDemo === false ? null : false));
  };

  // let navigate = useNavigate();
  let index = links?.links?.findIndex(x => x.id == curentId);
  useEffect(() => {
    let mounted = true;
    if (mounted && instanceData) {
      if (
        instanceData &&
        instanceData.Activities.Activity &&
        typeof instanceData.Activities.Activity.Instructions === 'object'
      ) {
        let data = [];
        if (instanceData.Activities.Activity) {
          for (let key in instanceData.Activities.Activity.Instructions) {
            data.push(instanceData.Activities.Activity.Instructions[key]);
          }
        }

        setInstructions(data);
      } else {
        setInstructions(
          instanceData && instanceData.Activities.Activity
            ? instanceData.Activities.Activity.Instructions
            : 'none'
        );
      }
    }

    return () => {
      mounted = false;
    };
  }, [instanceData]);

  useEffect(() => {
    setLiftedNextButtonFunction({
      func: flag => {
        if (!flag || (!result && (text !== '' || wpmValue > 0))) {
          handleWarningOpen();
        } else {
          // Reset logic if no text entered
          setShowRepsDataValue(0);
          setResult(false);
          setText('');
          setSeconds(0);
          setSecondflag(false);
          setError(0);
          setWordCount(0);
          setWpmValue(0);
          setErrorValueEach(0);
          setComparison([]);
          setAllText('');
          setCounter(() => Number(TimeLimit ?? 0));
          setAutomaticSubmit(false);
          setKeyData({});
          setParagraph('');
          setResultHTML2('');
          setResultHTML('');
          // Navigate immediately if no text
          handleNavigateAway();
        }
      }
    });
  }, []);

  const classes = useStyles();
  const replaced = val => {
    if (val === undefined) {
      return val;
    } else {
      val = val.toString()?.replace(/\//g, '');
      val = val.toString()?.replace(/\?/g, '');
      return val.toString()?.replace(/ /g, '_');
    }
  };
  // console.log(links?.links[index + 1].id);
  // console.log(index);
  // console.log(links?.links[index + 1]?.name);
  // console.log(links?.links?.length);
  // console.log(process.env.REACT_APP_ENV);
  // console.log(result, 'result');
  useEffect(() => {
    setWpmValue(0);
    setErrorValueEach(0);
    if (
      instanceData &&
      instanceData.Activities &&
      instanceData.Activities.Activity &&
      instanceData.Activities.Activity.attributes &&
      typeof instanceData.Activities.Activity.attributes.DisplayWAM === 'string'
    ) {
      const displayWAM = instanceData.Activities.Activity.attributes.DisplayWAM;
      const displayErrors = instanceData.Activities.Activity.attributes.DisplayErrors;
      if (displayWAM.toLowerCase() === 'true' || displayWAM === '1') {
        setWpmslag(true);
      } else {
        setWpmslag(false); // Optional, to handle other cases
      }

      if (displayErrors.toLowerCase() === 'true' || displayErrors === '1') {
        setErrorslag(true);
      } else {
        setErrorslag(false); // Optional, to handle other cases
      }
    }
  }, [instructions]); // Re-evaluates
  return (
    <Box>
      <Grid
        container
        rowspacing={{ xs: 1, md: 0 }}
        columnspacing={{ lg: 5 }}
        columns={12}
        style={{ paddingRight: '60px', paddingTop: '15px' }}>
        <Grid container item xs={12} lg={10}>
          <Grid align="left" className={classes.directions} item xs={'auto'}>
            {instructions &&
              (typeof instructions === 'object'
                ? Object.keys(instructions).length > 0 &&
                  Object.values(instructions).some(value => value && value.trim() !== '')
                : instructions.trim() !== '') &&
              (typeof instructions == 'object' ? (
                instructions[instructions.length - 1] == ' ' ? (
                  ' '
                ) : (
                  <Typography>Directions: </Typography>
                )
              ) : (
                <Typography>Directions: </Typography>
              ))}
          </Grid>
          <Grid align="left" item xs={10}>
            <Typography>
              {instructions ? (
                instructions === 'array' ? (
                  <ul>
                    {instructions.map(doc => {
                      return <li key={doc}>{doc}</li>;
                    })}
                  </ul>
                ) : (
                  instructions
                )
              ) : (
                <CircularProgress color="grey" size={10} />
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid container align="center" item xs={12} lg={2}>
           {/* CKey-112: Hide Navigation */}
          {navenable && links?.links[index - 1] ? (
            <Grid item xs={4}>
              {index === 0 ? (
                ''
              ) : (
                <>
                  <Tooltip title="Previous">
                    <div className="icon next-icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                      <ArrowLeftIcon
                        fontSize="large"
                        onClick={() => {
                          if (!result && (text !== '' || wpmValue > 0)) {
                            handlePreviousWarningOpen();
                          } else {
                            // Reset logic if no text entered
                            setShowRepsDataValue(0);
                            setResult(false);
                            setText('');
                            setSeconds(0);
                            setSecondflag(false);
                            setError(0);
                            setWordCount(0);
                            setComparison([]);
                            setAllText('');
                            setCounter(() => Number(TimeLimit ?? 0));
                            setAutomaticSubmit(false);
                            setParagraph('');
                            setResultHTML2('');
                            setResultHTML('');
                            setKeyData({});
                            const prevVisibleLink = [...(links?.links || [])]
                              .slice(0, index) // take all items before the current index
                              .reverse() // reverse to find the nearest previous one
                              .find(item => item.visible === 1);

                            if (prevVisibleLink) {
                              const prevLink = prevVisibleLink.name.split(' ').includes('Document')
                                ? `/courses/editor/${replaced(prevVisibleLink.name)}-${replaced(
                                    prevVisibleLink.id
                                  )}`
                                : `/courses/typing/${replaced(prevVisibleLink.name)}-${replaced(
                                    prevVisibleLink.id
                                  )}`;

                              navigate(prevLink, { state: links });
                              window.location.reload();
                            } else {
                              console.warn('No previous visible exercise found');
                              // Optionally show message or disable previous navigation
                            }
                          }
                        }}
                      />
                    </div>
                  </Tooltip>
                  <Dialog
                    open={openPrevious}
                    onClose={handlePreviousWarningClose}
                    aria-labelledby="warning-dialog-title"
                    aria-describedby="warning-dialog-description"
                    PaperProps={{
                      sx: {
                        borderRadius: '8px', // Updated border-radius
                        padding: '16px' // Added padding
                      }
                    }}>
                    <DialogTitle
                      id="warning-dialog-title"
                      style={{
                        display: 'flex',
                        fontWeight: 'bold',
                        fontSize: '18px'
                      }}>
                      Warning
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#333',
                          fontSize: '16px',
                          fontWeight: '500'
                        }}>
                        <img
                          src={warningIcon}
                          alt="Warning"
                          style={{ width: '50px', height: '50px', marginRight: '10px' }}
                        />
                        By navigating away from the current activity, you will delete your attempt
                        and your work will not be saved. Are you sure you want to do this now?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: '2px' }}>
                      <Button
                        style={{
                          color: '#D32F2F',
                          border: '1px solid #D32F2F',
                          fontWeight: 'bold',
                          padding: '0px 35px',
                          borderRadius: '4px'
                        }}
                        variant="outlined"
                        onClick={handlePreviousWarningClose}>
                        CANCEL
                      </Button>
                      <Button
                        style={{
                          backgroundColor: '#0D47A1',
                          color: 'white',
                          fontWeight: 'bold',
                          padding: '0px 50px',
                          borderRadius: '4px'
                        }}
                        variant="contained"
                        onClick={() => {
                          const prevVisibleLink = [...(links?.links || [])]
                            .slice(0, index) // take all items before the current index
                            .reverse() // reverse to find the nearest previous one
                            .find(item => item.visible === 1);

                          if (prevVisibleLink) {
                            const prevLink = prevVisibleLink.name.split(' ').includes('Document')
                              ? `/courses/editor/${replaced(prevVisibleLink.name)}-${replaced(
                                  prevVisibleLink.id
                                )}`
                              : `/courses/typing/${replaced(prevVisibleLink.name)}-${replaced(
                                  prevVisibleLink.id
                                )}`;
                            navigate(prevLink, { state: links });
                            if (exerciseType === 'TimingKeypadEnter') {
                              window.location.reload();
                            }
                          } else {
                            console.warn('No previous visible exercise found');
                            // Optionally show message or disable previous navigation
                          }
                          setShowRepsDataValue(0);
                          setResult(false);
                          setText('');
                          setSeconds(0);
                          setSecondflag(false);
                          setError(0);
                          setWordCount(0);
                          setComparison([]);
                          setWpmValue(0);
                          setErrorValueEach(0);
                          setAllText('');
                          setParagraph('');
                          setKeyData({});
                          setCounter(() => Number(TimeLimit));
                          setAutomaticSubmit(false);
                          handlePreviousWarningClose();
                          if (exerciseType === 'TimingKeypadEnter') {
                            window.location.reload();
                          }
                        }}>
                        OK
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              )}
            </Grid>
          ) : (
            ''
          )}
          
          <Grid item xs={4}>
            <WarningModal
              ele={
                <div className="icon next-icon" style={{ cursor: 'pointer', color: '#124c72' }}>
                  <ReplayIcon
                    fontSize="large"
                    onClick={() => {
                      // CKey-112
                      // window.location.reload();
                      const token = sessionStorage.getItem('jswtoken');
                      if (token) {
                        sessionStorage.setItem(
                          'restartData',
                          JSON.stringify({
                            pathname: location.pathname,
                            state: location.state,

                            activityInstance: sessionStorage.getItem('activityInstance'),
                            userid: sessionStorage.getItem('userid'),
                            username: sessionStorage.getItem('username'),
                            userEmail: sessionStorage.getItem('userEmail'),
                            activityID: sessionStorage.getItem('activityID'),
                            navigation: sessionStorage.getItem('navigation'),
                            token: sessionStorage.getItem('jswtoken')
                        
                          })
                        );
                        navigate('/restart-session');
                      } else {
                        window.location.reload();
                      }
                    }}
                  />
                </div>
              }
              type="replay"
              setReplayClick={setReplayClick}
              replayClick={replayClick}
              title="Restart"
              setResult={setResult}
              setText={setText}
              setShowRepsDataValue={setShowRepsDataValue}
              text={text}
              setSeconds={setSeconds}
              setError={setError}
              setWordCount={setWordCount}
              setComparison={setComparison}
              result={result}
              setAllText={setAllText}
              setParagraph={setParagraph}
              TimeLimit={TimeLimit}
              setCounter={setCounter}
              setAutomaticSubmit={setAutomaticSubmit}
              setSecondflag={setSecondflag}
              setErrorValueEach={setErrorValueEach}
              setWpmValue={setWpmValue}
              paragraph={paragraph}
              setReplay={setReplay}
              counter={counter}
              path={location.pathname}
              links={links}
              exerciseType={exerciseType}
            />
          </Grid>
          { /* CKey-112: Hide Navigation */ }
          { navenable && (
          process.env.REACT_APP_ENV === 'development' ? (
            <Grid item xs={4}>
              {index === links?.links?.length ||
              links?.links[0].id === links?.links[index + 1].id ? (
                ''
              ) : (
                <>
                  <Tooltip title="Next">
                    <div className="icon next-icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                      <ArrowRightIcon
                        fontSize="large"
                        onClick={() => {
                          if (!result && (text !== '' || wpmValue > 0)) {
                            handleWarningOpen();
                          } else {
                            // Reset logic if no text entered
                            setShowRepsDataValue(0);
                            setResult(false);
                            setText('');
                            setSeconds(0);
                            setSecondflag(false);
                            setError(0);
                            setWordCount(0);
                            setWpmValue(0);
                            setErrorValueEach(0);
                            setComparison([]);
                            setAllText('');
                            setCounter(() => Number(TimeLimit ?? 0));
                            setAutomaticSubmit(false);
                            setKeyData({});
                            setParagraph('');
                            setResultHTML2('');
                            setResultHTML('');
                            // Navigate immediately if no text
                            handleNavigateAway();
                            window.location.reload();
                          }
                        }}
                      />
                    </div>
                  </Tooltip>

                  { /* Warning Dialog */ } 
                  <Dialog
                    open={open}
                    onClose={handleWarningClose}
                    aria-labelledby="warning-dialog-title"
                    aria-describedby="warning-dialog-description"
                    PaperProps={{
                      sx: {
                        borderRadius: '8px', // Updated border-radius
                        padding: '16px' // Added padding
                      }
                    }}>
                    <DialogTitle
                      id="warning-dialog-title"
                      style={{
                        display: 'flex',
                        fontWeight: 'bold',
                        fontSize: '18px'
                      }}>
                      Warning
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#333',
                          fontSize: '16px',
                          fontWeight: '500'
                        }}>
                        <img
                          src={warningIcon}
                          alt="Warning"
                          style={{ width: '50px', height: '50px', marginRight: '10px' }}
                        />
                        By navigating away from the current activity, you will delete your attempt
                        and your work will not be saved. Are you sure you want to do this now?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: '2px' }}>
                      <Button
                        style={{
                          color: '#D32F2F',
                          border: '1px solid #D32F2F',
                          fontWeight: 'bold',
                          padding: '0px 35px',
                          borderRadius: '4px'
                        }}
                        variant="outlined"
                        onClick={handleWarningClose}>
                        CANCEL
                      </Button>
                      <Button
                        style={{
                          backgroundColor: '#0D47A1',
                          color: 'white',
                          fontWeight: 'bold',
                          padding: '0px 50px',
                          borderRadius: '4px'
                        }}
                        variant="contained"
                        onClick={() => {
                          handleWarningClose(); // Close the dialog
                          handleNavigateAway(); // Trigger navigation
                        }}>
                        OK
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              )}
            </Grid>
          ) : (
            <Grid item xs={4}>
              {index === links?.links?.length - 1 ? (
                ''
              ) : (
                <>
                  <Tooltip title="Next">
                    <div className="icon next-icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                      <ArrowRightIcon
                        fontSize="large"
                        onClick={() => {
                          if (!result && (text !== '' || wpmValue > 0)) {
                            handleWarningOpen();
                          } else {
                            // Reset logic if no text entered
                            setShowRepsDataValue(0);
                            setResult(false);
                            setText('');
                            setSeconds(0);
                            setSecondflag(false);
                            setError(0);
                            setWordCount(0);
                            setComparison([]);
                            setAllText('');
                            setCounter(() => Number(TimeLimit ?? 0));
                            setAutomaticSubmit(false);
                            setKeyData({});
                            setParagraph('');
                            setResultHTML2('');
                            setResultHTML('');
                            // Navigate immediately if no text
                            handleNavigateAway(); // Define this for navigation
                            window.location.reload();
                          }
                        }}
                      />
                    </div>
                  </Tooltip>

                  { /* Warning Dialog */ }
                  <Dialog
                    open={open}
                    onClose={handleWarningClose}
                    aria-labelledby="warning-dialog-title"
                    aria-describedby="warning-dialog-description"
                    PaperProps={{
                      sx: {
                        borderRadius: '8px', // Updated border-radius
                        padding: '16px' // Added padding
                      }
                    }}>
                    <DialogTitle
                      id="warning-dialog-title"
                      style={{
                        display: 'flex',
                        fontWeight: 'bold',
                        fontSize: '18px'
                      }}>
                      Warning
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#333',
                          fontSize: '16px',
                          fontWeight: '500'
                        }}>
                        <img
                          src={warningIcon}
                          alt="Warning"
                          style={{ width: '50px', height: '50px', marginRight: '10px' }}
                        />
                        By navigating away from the current activity, you will delete your attempt
                        and your work will not be saved. Are you sure you want to do this now?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: '2px' }}>
                      <Button
                        style={{
                          color: '#D32F2F',
                          border: '1px solid #D32F2F',
                          fontWeight: 'bold',
                          padding: '0px 35px',
                          borderRadius: '4px'
                        }}
                        variant="outlined"
                        onClick={handleWarningClose}>
                        CANCEL
                      </Button>
                      <Button
                        style={{
                          backgroundColor: '#0D47A1',
                          color: 'white',
                          fontWeight: 'bold',
                          padding: '0px 50px',
                          borderRadius: '4px'
                        }}
                        variant="contained"
                        onClick={() => {
                          handleWarningClose(); // Close the dialog
                          const nextVisibleLink = links?.links
                            ?.slice(index + 1)
                            .find(item => item.visible === 1);

                          if (nextVisibleLink) {
                            const path = nextVisibleLink.name.split(' ').includes('Document')
                              ? `/courses/editor/${replaced(nextVisibleLink.name)}-${replaced(
                                  nextVisibleLink.id
                                )}`
                              : `/courses/typing/${replaced(nextVisibleLink.name)}-${replaced(
                                  nextVisibleLink.id
                                )}`;

                            navigate(path, { state: links });

                            if (exerciseType === 'TimingKeypadEnter') {
                              window.location.reload();
                            }
                          } else {
                            console.warn('No next visible exercise found');
                            // Optionally navigate to a fallback route or show a message
                          }
                          setShowRepsDataValue(0);
                          setResult(false);
                          setText('');
                          setSeconds(0);
                          setSecondflag(false);
                          setError(0);
                          setWordCount(0);
                          setComparison([]);
                          setAllText('');
                          setParagraph('');
                          setKeyData({});
                          setCounter(() => Number(TimeLimit));
                          setAutomaticSubmit(false);
                          if (exerciseType === 'TimingKeypadEnter') {
                            window.location.reload();
                          }
                        }}>
                        OK
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
                )}
              </Grid>
                )
             )}
          <Grid item xs={6}>
            {instanceData &&
              instanceData.Activities.Activity &&
              instanceData.Activities.Activity.attributes.Videopath &&
              instanceData.Activities.Activity.attributes.Videopath !== 'NA' &&
              instanceData.Activities.Activity.attributes.VideoLocation &&
              instanceData.Activities.Activity.attributes.VideoLocation !== 'NA' && (
                <Tooltip title="Show/Hide Video Demo">
                  <div
                    style={{ marginTop: '10px' }}
                    className={demo === true ? 'iconActive icon' : 'icon'}>
                    <VideoSymbol
                      style={{
                        width: '24px',
                        height: '24px',
                        cursor: 'pointer'
                      }}
                      onClick={showVideoDemo}
                    />
                  </div>
                </Tooltip>
              )}
          </Grid>
          <Grid align="center" item xs={6}>
            {instanceData &&
              instanceData.Activities.Activity &&
              instanceData.Activities.Activity.attributes.Kbpath &&
              instanceData.Activities.Activity.attributes.Kbpath !== 'NA' &&
              instanceData.Activities.Activity.attributes.GraphicLocation &&
              instanceData.Activities.Activity.attributes.GraphicLocation !== 'NA' && (
                <Tooltip title="Show/Hide Keyboard">
                  <div
                    style={{ marginTop: '10px' }}
                    className={demo === false ? 'iconActive icon' : 'icon'}>
                    <img
                      src={KeyboardSymbol}
                      style={{ width: '22px', height: '22px', cursor: 'pointer' }}
                      onClick={showKeyBoardHint}
                    />
                  </div>
                </Tooltip>
              )}
          </Grid>
        </Grid>
      </Grid>
      <Divider
        style={{
          height: '3px',
          margin: '10px 0'
        }}
      />
      {exerciseType && exerciseType === 'Timed Short Drill' ? null : (
        <>
          {instanceData &&
          instanceData.Activities.Activity &&
          instanceData.Activities.Activity.attributes.Type === 'Document' ? null : (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography>
                {instanceData &&
                instanceData.Activities.Activity &&
                typeof instanceData.Activities.Activity.Prompts === 'string'
                  ? instanceData.Activities.Activity.Prompts
                  : null}
              </Typography>
              <Typography
                style={{
                  fontWeight: 'bold',
                  color: '#000',
                  fontSize: '14px',
                  marginLeft: 'auto',
                  marginRight: '10px'
                }}>
                {/* Only render WPM if wpmslag true */}
                {wpmslag && `WPM: ${wpmValue} `}
                {/* Only render Error errorslag true */}
                {errorslag && `Error: ${errorValueEach}`}
              </Typography>
            </div>
          )}
        </>
      )}
    </Box>
  );
};

export default TypingTestHeader;
